const CommentDeleted = () => {
  return <p className="dead">Deleted Comment</p>;
}
 
export default CommentDeleted;